// Treemoda: translated slider labels for screen readers (Swiper defaults are English). Messages come from window.tmA11y.
(function () {
  if (window.Swiper && Swiper.extendDefaults && window.tmA11y) {
    Swiper.extendDefaults({ a11y: { enabled: true, prevSlideMessage: tmA11y.prev, nextSlideMessage: tmA11y.next, firstSlideMessage: tmA11y.first, lastSlideMessage: tmA11y.last, paginationBulletMessage: String(tmA11y.bullet).replace('__N__', '{{index}}') } });
  }
})();
